class InfluencerHandler extends HTMLElement {
	constructor() {
		super();
		this.fallBackMessage = 'Pour tout achat d’un fit shake (seul ou inclus dans un pack), reçois fit banana en cadeau!';
		this.cartNotification = document.querySelector('cart-notification');
		console.log('InfluencerHandler');
		this.setUpParameters();
		// this.checkURL();
	}

	setUpParameters() {
		// Set up parameters
		({
			influencerCampaign: this.influencerCampaign,
			influencerContents: this.influencerContents,
			message: this.message,
			variantId: this.variantId,
		} = this.dataset);
    console.log('this.dataset', this.dataset);
		if (!this.influencerCampaign || !this.influencerContents || !this.variantId) {
			console.error('InfluencerHandler: missing parameters');
			return;
		}
		this.checkURL();
	}

	checkURL() {
		// Check url for influencer code utm_content
		const url = new URL(window.location.href);
		const influencerCode = url.searchParams.get(this.influencerCampaign);
    const acceptedUTMContents = this.influencerContents.split(','); // e.g. ['influencer1', 'influencer2'] ;
		if (influencerCode && acceptedUTMContents.includes(influencerCode)) {
			this.checkIfGiftAlreadyInCart();
		}
	}

	checkIfGiftAlreadyInCart() {
		// Check if gift is already in cart
		let config = fetchConfig('javascript');
		console.log('config', config);
		fetch(`${routes.cart_url}.js`, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					console.log(response);
					return;
				}
				console.log('response', response);
				let items = response.items;
				let giftAlreadyInCart = false;
				items.forEach((item) => {
					if (item.properties._influencer_gift) {
						giftAlreadyInCart = true;
					}
				});
				if (!giftAlreadyInCart) {
					this.addProductToCart();
				}
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				console.log('done');
			});
	}

	addProductToCart() {
		// Add product to cart (fit banana with variantId: 47078972850510)
		let config = fetchConfig('javascript');
		console.log('config', config);
		let data = {
			items: [
				{
					id: this.variantId,
					quantity: 1,
					properties: {
						_influencer_gift: 'true',
					},
				},
			],
			sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
			sections_url: window.location.pathname,
		};
		config.body = JSON.stringify(data);
		fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					console.log(response);
					return;
				}
				this.cartNotification.renderContents(response, this.message);
			})
			.finally(() => {
				console.log('done');
			});
	}
}

if (!customElements.get('influencer-handler')) {
	customElements.define('influencer-handler', InfluencerHandler);
}
